module.exports = __webpack_public_path__ + "img/performance.e9c102c3.svg";